import React from 'react';

import { Stack } from '@mui/material';
import { MasteryHeatMapHeader } from './MasteryHeatMapHeader';
import { MasteryHeatMapGrid } from './MasteryHeatMapGrid';
import { type StudentDayStats } from '../model';

type Props = {
  data: Record<string, StudentDayStats> | undefined;
};

export const MasteryHeatMap = ({ data }: Props) => (
  <Stack>
    <MasteryHeatMapHeader />
    <MasteryHeatMapGrid data={data} />
  </Stack>
);
